import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlyvihiclerentalswithdriverinbanglore() {



  const cardData =
  {
    keyword: 'Monthly Vehicle Rentals with Drivers in Bangalore',
    heading: 'Aaryan Travels: Monthly Vehicle Rentals with Drivers in Bangalore',
    headingDescription: ' Aaryan Travels provides flexible Monthly Vehicle Rentals with Drivers in Bangalore for corporate employees, executives, and long-term travelers who require convenient daily transportation. Whether you need a sedan for office commute, an SUV for managerial travel, or a tempo traveller for staff movement, our chauffeur-driven vehicles are available on fixed monthly contracts with transparent billing. With professional drivers, GPS-enabled cars, on-time reporting, and 24/7 support, we ensure reliable mobility across key business zones like Whitefield, Electronic City, Koramangala, Marathahalli, and Manyata Tech Park. Aaryan Travels makes long-term travel effortless with customizable rental plans that eliminate the hassle of daily cab booking.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a historic green haven spread across 240 acres, known for its rare plant species, serene lakes, and glasshouse inspired by London’s Crystal Palace. The annual flower show attracts thousands of visitors. Joggers, nature lovers, and photographers frequent its peaceful trails. The garden offers a refreshing retreat from city life. Lalbagh is Bangalore’s blooming oasis of nature."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, resembles England’s Windsor Castle with its Tudor-style architecture, wooden interiors, and sprawling gardens. Visitors admire royal collections, vintage photographs, and elegant ballrooms. Concerts and cultural events are often hosted on the palace grounds. The majestic structure reflects royal heritage and charm. Bangalore Palace is the city’s symbol of regal grandeur."
  },
  {
        "title": "Cubbon Park",
        "description": "Cubbon Park is a lush 300-acre urban park offering wide green lawns, walking trails, and stately colonial-era buildings. Known as the 'Lungs of Bangalore', it is ideal for morning walks and nature breaks. Statues, fountains, and children’s play zones enhance its charm. Locals enjoy weekend picnics under its giant trees. Cubbon Park is Bangalore’s green escape in the heart of the city."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple is a grand architectural marvel dedicated to Lord Krishna, featuring gold-plated kalashas and spiritual exhibitions. Devotees attend soothing kirtans and arati ceremonies. The temple complex includes a Vedic museum and Govinda’s restaurant serving sattvic meals. The peaceful ambiance uplifts the soul. ISKCON Temple is Bangalore’s spiritual lighthouse."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from Bangalore, Nandi Hills is a popular hilltop getaway known for stunning sunrise views and cool breezes. The historic Tipu Sultan's Summer Palace and ancient temples add cultural charm. Clouds often envelope the hill, creating a heavenly feel. Cycling and trekking enthusiasts love the scenic route. Nandi Hills is Bangalore’s perfect dawn escape."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most bustling shopping destination filled with fashion boutiques, footwear stalls, accessories, and street food. Bargain hunters explore every lane for trendy deals. From ethnic wear to western outfits, the variety is endless. Evenings are lively with vibrant crowds. Commercial Street is Bangalore’s shopping paradise."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an imposing granite structure housing the Karnataka State Legislature. Built in Neo-Dravidian style, it stands tall with grand staircases, domes, and inscriptions. Though entry inside is restricted, tourists admire it from outside, especially when illuminated at night. It reflects political power and architectural elegance. Vidhana Soudha is Bangalore’s pride of governance."
  },
  {
    "title": "UB City",
    "description": "UB City is Bangalore’s most luxurious commercial complex featuring premium brands, fine dining restaurants, and rooftop lounges. The European-style architecture and vibrant nightlife attract elites and travelers. The open-air amphitheater often hosts live music and events. It is a hotspot for corporate meets and glamorous evenings. UB City is Bangalore’s hub of luxury and lifestyle."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park is a wildlife reserve featuring safari rides where visitors can spot lions, tigers, bears, and deer in natural habitats. It also includes a butterfly park and zoo section. Adventure seekers enjoy trekking in nearby forest zones. Educational and thrilling, it’s ideal for families. Bannerghatta is Bangalore’s wild nature adventure."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road together form Bangalore’s iconic commercial stretch buzzing with cafes, pubs, bookstores, and shopping outlets. Known for nightlife and street energy, it is a favorite spot for youngsters. Illuminated signboards and busy pedestrian lanes create a vibrant city vibe. MG Road is Bangalore’s pulse of entertainment and urban culture."
  }
],


"services": [
  {
    "name": "Monthly Vehicle Rentals with Drivers in Bangalore",
    "description": "Our Monthly Vehicle Rentals with Drivers in Bangalore provide flexible and cost-effective transportation solutions for long-term needs. Ideal for corporate clients and individuals alike, this service offers well-maintained vehicles driven by professional chauffeurs, ensuring comfort, safety, and punctuality throughout the rental period."
  },
  {
    "name": "Bangalore Monthly Car Hire with Driver",
    "description": "Bangalore Monthly Car Hire with Driver offers seamless monthly car rental options with experienced drivers. Perfect for daily commutes, business travel, or extended trips, this service guarantees reliable vehicles and professional service tailored to your schedule."
  },
  {
    "name": "Chauffeur Monthly Vehicle Rental Bangalore",
    "description": "Chauffeur Monthly Vehicle Rental Bangalore provides dedicated chauffeur-driven vehicles for long-term rentals. Enjoy stress-free transportation with courteous drivers who understand your needs, ensuring timely pickups and drop-offs every day."
  },
  {
    "name": "Long-Term Vehicle Rental Bangalore",
    "description": "Long-Term Vehicle Rental Bangalore caters to clients needing vehicles for extended periods, combining affordability with premium service. Choose from sedans, SUVs, and other vehicle types, all maintained for optimal comfort and safety during your rental."
  },
  {
    "name": "Corporate Monthly Rentals Bangalore",
    "description": "Corporate Monthly Rentals Bangalore specializes in customized vehicle leasing plans for businesses. Streamline employee transport and executive travel with flexible monthly packages that include professional chauffeurs, transparent billing, and priority support."
  },
  {
    "name": "Affordable Monthly Driver Rentals Bangalore",
    "description": "Affordable Monthly Driver Rentals Bangalore delivers budget-friendly long-term vehicle hire solutions with skilled drivers. Ideal for startups and SMEs, this service ensures reliable transportation without compromising on quality or professionalism."
  },
  {
    "name": "Sedan Monthly Driver Rental Bangalore",
    "description": "Sedan Monthly Driver Rental Bangalore offers premium sedans with experienced drivers on a monthly basis. Perfect for business professionals and small groups seeking comfortable and efficient daily travel."
  },
  {
    "name": "SUV Monthly Driver Hire Bangalore",
    "description": "SUV Monthly Driver Hire Bangalore provides spacious SUVs with chauffeurs for monthly rentals. Suitable for larger groups and families, this service combines luxury, space, and safety for extended travel requirements."
  },
  {
    "name": "Best Monthly Vehicle Rentals Bangalore",
    "description": "Our Best Monthly Vehicle Rentals Bangalore service ensures top-quality vehicles and reliable chauffeurs for consistent monthly transportation. Enjoy personalized service, on-time pickups, and well-maintained cars for a hassle-free experience."
  },
  {
    "name": "Corporate Vehicle Leasing Bangalore",
    "description": "Corporate Vehicle Leasing Bangalore offers businesses long-term leasing solutions with flexible terms. Benefit from dedicated fleet management, professional drivers, and tailored packages to support your company’s travel demands."
  },
  {
    "name": "Monthly Chauffeur Service Bangalore",
    "description": "Monthly Chauffeur Service Bangalore provides professional drivers for extended rentals, ensuring courteous, punctual, and discreet service for executives and regular travelers."
  },
  {
    "name": "Monthly Car with Driver Bangalore",
    "description": "Monthly Car with Driver Bangalore makes long-term car rentals easy with skilled drivers included. Perfect for individuals and companies looking for hassle-free monthly vehicle hire with dependable service."
  },
  {
    "name": "Online Monthly Rentals Bangalore",
    "description": "Online Monthly Rentals Bangalore allows you to book and manage your monthly vehicle rentals easily through a convenient digital platform. Schedule rides, track usage, and access support with just a few clicks."
  },
  {
    "name": "Bangalore Vehicle Subscription With Driver",
    "description": "Bangalore Vehicle Subscription With Driver offers flexible subscription-based vehicle rentals including chauffeurs. Enjoy the benefits of monthly vehicle use without the hassles of ownership or long-term contracts."
  },
  {
    "name": "Monthly Vehicle Hire Bangalore",
    "description": "Monthly Vehicle Hire Bangalore provides comprehensive monthly rental plans suited to your travel needs, featuring a wide range of vehicles and experienced drivers to ensure safety and comfort."
  }
],
"tableData": [
  ["Monthly Vehicle Rentals with Drivers in Bangalore", "Bangalore Monthly Car Hire with Driver"],
  ["Chauffeur Monthly Vehicle Rental Bangalore", "Long-Term Vehicle Rental Bangalore"],
  ["Corporate Monthly Rentals Bangalore", "Affordable Monthly Driver Rentals Bangalore"],
  ["Sedan Monthly Driver Rental Bangalore", "SUV Monthly Driver Hire Bangalore"],
  ["Best Monthly Vehicle Rentals Bangalore", "Corporate Vehicle Leasing Bangalore"],
  ["Monthly Chauffeur Service Bangalore", "Monthly Car with Driver Bangalore"],
  ["Online Monthly Rentals Bangalore", "Bangalore Vehicle Subscription With Driver"],
  ["Monthly Vehicle Hire Bangalore", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Monthly Vehicle Rentals with Drivers in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers flexible and cost-effective monthly vehicle rentals with professional drivers throughout Bangalore."
  },
  {
    "WhyChooseheading": "Convenient and Timely Pickup for Your Daily Commutes",
    "WhyChoosedescription": "Our drivers ensure punctual pickups and smooth rides for your regular travel needs across the city."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars maintained to the highest standards of safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Bangalore Traffic and Routes",
    "WhyChoosedescription": "Our professional drivers know the city well to provide efficient and hassle-free transportation."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Monthly Rental Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, modifications, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Suit Your Business or Personal Needs",
    "WhyChoosedescription": "Choose from a variety of plans that fit your monthly commuting or travel requirements."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Accommodate All Group Sizes",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage needs."
  }
]






































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly vehicle rentals with drivers in Bangalore?',
    answer: 'Yes, Aaryan Travels provides flexible and affordable monthly vehicle rental services with professional drivers in Bangalore.',
  },
  {
    question: 'How can I book monthly vehicle rentals with drivers in Bangalore?',
    answer: 'You can book monthly rentals through our website, mobile app, or by contacting our customer support team.',
  },
  {
    question: 'What types of vehicles are available for monthly rentals in Bangalore?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and premium cars for monthly rental packages.',
  },
  {
    question: 'Are the drivers experienced and familiar with Bangalore routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with Bangalore’s traffic and routes.',
  },
  {
    question: 'Can monthly vehicle rentals with drivers be customized for specific business needs?',
    answer: 'Yes, we offer customized monthly rental plans tailored to your personal or corporate travel requirements.',
  },
  {
    question: 'Is the monthly rental service with drivers available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels provides round-the-clock service for monthly vehicle rentals with drivers in Bangalore.',
  },
  {
    question: 'What safety and hygiene protocols are followed for monthly rentals with drivers?',
    answer: 'All vehicles are regularly sanitized and our drivers follow strict safety and hygiene measures to ensure passenger safety.',
  },
  {
    question: 'Can I change pickup and drop-off locations during the rental period?',
    answer: 'Yes, pickup and drop-off locations can be customized and changed based on your travel needs during the rental period.',
  },
  {
    question: 'What payment options are available for monthly vehicle rentals with drivers?',
    answer: 'We accept cash, cards, UPI, and digital wallets for convenient and hassle-free payments.',
  },
  {
    question: 'Can I pre-book monthly vehicle rentals with drivers in Bangalore?',
    answer: 'Yes, Aaryan Travels allows advance bookings to ensure vehicle availability for your monthly rental needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karthik Rao',
    feedback: 'Aaryan Travels made monthly vehicle rental with driver in Bangalore seamless and hassle-free. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Nair',
    feedback: 'Professional drivers and well-maintained cars. Monthly rental service in Bangalore through Aaryan Travels is top-notch.',
    rating: 5,
  },
];
































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Vehicle Rentals with Drivers in Bangalore",
  "image": "https://aaryantravels.com/assets/images/monthly-vehicle-rentals-with-drivers-in-bangalore.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers affordable and flexible monthly vehicle rentals with drivers in Bangalore. Choose from sedans, SUVs, and luxury cars with professional chauffeurs for corporate or personal use.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating
    "ratingCount": "3100", // example count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "25000",  // example monthly rental rate
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/monthly-vehicle-rentals-with-drivers-in-bangalore"
  }
};





  return (
    <div>

<Helmet>
  <title>Monthly Vehicle Rentals with Drivers in Bangalore | Affordable Chauffeur Services | Aaryan Travels</title>
  <meta
    name="description"
    content="Aaryan Travels offers affordable and flexible monthly vehicle rentals with drivers in Bangalore. Choose from sedans, SUVs, and luxury cars with professional chauffeurs for corporate or personal use."
  />
  <meta
    name="keywords"
    content="Monthly Vehicle Rentals with Drivers in Bangalore, Bangalore Monthly Car Hire with Driver, Chauffeur Monthly Vehicle Rental Bangalore, Long-Term Vehicle Rental Bangalore, Corporate Monthly Rentals Bangalore, Affordable Monthly Driver Rentals Bangalore, Sedan Monthly Driver Rental Bangalore, SUV Monthly Driver Hire Bangalore, Best Monthly Vehicle Rentals Bangalore, Corporate Vehicle Leasing Bangalore, Monthly Chauffeur Service Bangalore, Monthly Car with Driver Bangalore, Online Monthly Rentals Bangalore, Bangalore Vehicle Subscription With Driver, Monthly Vehicle Hire Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlyvihiclerentalswithdriverinbanglore;